import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { FormResetter as Component } from './form-resetter';
import type { TFormResetterProps } from './models';

export const FormResetter = createWidget<unknown, TFormResetterProps>()(Component);
